module.exports = __webpack_public_path__ + "img/20190523214528820.320cc5a0.jpg";